<div class="m-banner-seat-selection" (click)="goToSeatSelectionPage()">
  <figure>
    <img src="assets/img/seats.svg" alt="Seats">
  </figure>
  <div class="text">
    <h3>Choix des places sur plan</h3>
    <p>Cliquez pour choisir vos sièges</p>
  </div>
</div>
